import { render, staticRenderFns } from "./vipEquity.vue?vue&type=template&id=0e97471d&scoped=true"
import script from "./vipEquity.vue?vue&type=script&lang=js"
export * from "./vipEquity.vue?vue&type=script&lang=js"
import style0 from "./vipEquity.vue?vue&type=style&index=0&id=0e97471d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97471d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e97471d')) {
      api.createRecord('0e97471d', component.options)
    } else {
      api.reload('0e97471d', component.options)
    }
    module.hot.accept("./vipEquity.vue?vue&type=template&id=0e97471d&scoped=true", function () {
      api.rerender('0e97471d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketingManage/vipManage/vipEquity.vue"
export default component.exports